import React from 'react';

const FinalCTA = ({ onOrderClick }) => {
  return (
    <section className="py-20 bg-gradient-to-br from-green-500 via-green-600 to-green-700 text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Don't Let Your Customers Walk Away Forever
        </h2>
        <p className="text-xl md:text-2xl mb-8 text-green-100">
          Every day without MPillar AIQR Kit, you're losing customers you'll never reach again.
        </p>

        <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-8 mb-8">
          <div className="grid md:grid-cols-3 gap-6 mb-8">
            <div>
              <p className="text-5xl font-bold mb-2">₹1,999</p>
              <p className="text-green-100">One-Time Investment</p>
            </div>
            <div>
              <p className="text-5xl font-bold mb-2">Unlimited</p>
              <p className="text-green-100">Leads Forever</p>
            </div>
            <div>
              <p className="text-5xl font-bold mb-2">40%+</p>
              <p className="text-green-100">Sales Increase</p>
            </div>
          </div>

          <button
            onClick={onOrderClick}
            className="bg-white text-green-600 hover:bg-gray-100 px-12 py-5 rounded-xl font-bold text-xl transition-all transform hover:scale-105 shadow-2xl"
            data-testid="final-cta-button"
          >
            🚀 YES! I WANT TO GROW MY BUSINESS
          </button>

          <div className="mt-6 space-y-2 text-green-100">
            <p>✓ Only 23 Kits Left in Stock</p>
            <p>✓ 30-Day Money-Back Guarantee</p>
            <p>✓ Free Setup Support & Training</p>
          </div>
        </div>

        <div className="bg-yellow-500 text-gray-900 rounded-xl p-6 font-semibold">
          ⚠️ WARNING: Price increases to ₹3,999 tomorrow. This is your last chance to save ₹2,000!
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-8 text-left">
          <div>
            <h3 className="font-bold text-xl mb-3">🛡️ Risk-Free</h3>
            <p className="text-green-100">30-day money-back guarantee. If you don't love it, get a full refund.</p>
          </div>
          <div>
            <h3 className="font-bold text-xl mb-3">🚀 Easy Setup</h3>
            <p className="text-green-100">Works in 30 seconds. No technical knowledge needed. We help you set up.</p>
          </div>
          <div>
            <h3 className="font-bold text-xl mb-3">💰 ROI Guaranteed</h3>
            <p className="text-green-100">Just 2-3 repeat customers and you've earned back your investment!</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;